
export function getChannelIcon(channelId: number) {
  switch (channelId) {
    case 2018: // airbnbOfficial
      return (
        <i
          className="lab la-airbnb text-[32px] text-red-600"
          style={{ color: "#FF5A5F" }}
        />
      );
    case 2002: // homeaway
      return <i className="la la-globe" />;
    case 2005: // bookingcom
      return <i className="la la-globe" />;
    case 2007: // expedia
      return <i className="la la-globe" />;
    case 2009: // homeawayical
      return <i className="la la-globe" />;
    case 2010: // vrboical
      return <i className="la la-globe" />;
    case 2000: // direct
      return <i className="la la-globe" />;
    case 2013: // bookingengine
      return <i className="la la-globe" />;
    case 2015: // customIcal
      return <i className="la la-globe" />;
    case 2016: // tripadvisorical
      return <i className="la la-globe" />;
    case 2017: // wordpress
      return <i className="la la-wordpress" />;
    case 2019: // marriott
      return <i className="la la-globe" />;
    case 2020: // partner
      return <i className="la la-globe" />;
    case 2021: // gds
      return <i className="la la-globe" />;
    case 2022: // google
      return <i className="lab la-google" />;

    default:
      return null; 
  }
}